import { createApi } from '@core/fetch'

export default {
  getCourseGuide: createApi('/hms/light/adminApi/merchantTask/courseGuide')
}
